"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _base = require("block/base");

var _exports = babelHelpers.interopRequireDefault(require("exports"));

var _decorators = require("decorators");

var ConditionalToggleBlockContainer =
/*#__PURE__*/
function (_BlockContainer) {
  babelHelpers.inherits(ConditionalToggleBlockContainer, _BlockContainer);

  function ConditionalToggleBlockContainer() {
    babelHelpers.classCallCheck(this, ConditionalToggleBlockContainer);
    return babelHelpers.possibleConstructorReturn(this, babelHelpers.getPrototypeOf(ConditionalToggleBlockContainer).apply(this, arguments));
  }

  return ConditionalToggleBlockContainer;
}(_base.BlockContainer);

exports.default = ConditionalToggleBlockContainer;